import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Phone, WhatsApp } from "@material-ui/icons";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider, useTheme, Chip, Box } from "@material-ui/core";
import { isNil } from 'lodash';
import ShowTicketOpen from '../ShowTicketOpenModal';
import { grey } from '@material-ui/core/colors';

// 🎨 Estilos WhatsApp Moderno
const useWhatsAppStyles = makeStyles((theme) => ({
  contactCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '16px',
    padding: '20px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    minWidth: '300px',
    maxWidth: '340px',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    // '&:hover': {
    //   boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    //   transform: 'translateY(-4px)',
    // },
    // '&::before': {
    //   content: '""',
    //   position: 'absolute',
    //   top: 0,
    //   left: 0,
    //   right: 0,
    //   height: '4px',
    //   background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    // },
  },
  avatarSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '16px',
  },
  avatar: {
    width: '64px',
    height: '64px',
    border: `3px solid ${theme.palette.primary.main}`,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  avatarFallback: {
    width: '64px',
    height: '64px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontSize: '24px',
    fontWeight: 'bold',
    border: `3px solid ${theme.palette.primary.light}`,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  contactInfo: {
    flex: 1,
  },
  contactName: {
    fontWeight: 600,
    fontSize: '18px',
    color: theme.palette.text.primary,
    marginBottom: '6px',
    lineHeight: 1.2,
  },
  contactNumber: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    fontFamily: 'monospace',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '4px',
  },
  statusChip: {
    height: '20px',
    fontSize: '10px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  newContactChip: {
    backgroundColor: theme.palette.success.main,
    color: 'white',
  },
  existingContactChip: {
    backgroundColor: theme.palette.info.main,
    color: 'white',
  },
  actionSection: {
    marginTop: '16px',
    display: 'flex',
    gap: '12px',
  },
  actionButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    padding: '12px 24px',
    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    boxShadow: '0 3px 12px rgba(25, 118, 210, 0.3)',
    transition: 'all 0.2s ease',
    flex: 1,
    '&:hover': {
      background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
      boxShadow: '0 6px 20px rgba(25, 118, 210, 0.4)',
      transform: 'translateY(-2px)',
    },
    '&:disabled': {
      background: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
      boxShadow: 'none',
      transform: 'none',
    },
  },
  whatsappIcon: {
    marginRight: '8px',
    fontSize: '18px',
  },
}));

const VcardPreview = ({ contact, numbers, queueId, whatsappId }) => {
    const theme = useTheme();
    const classes = useWhatsAppStyles();
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;
    
    // 🐛 Debug logs para verificar se as props estão chegando
    console.log('🎯 VcardPreview props:', { contact, numbers, queueId, whatsappId });

    // 📱 Formatador de número de telefone
    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '';
        
        const cleaned = phoneNumber.replace(/\D/g, '');
        
        // Formato brasileiro: +55 11 99999-9999
        if (cleaned.length === 13 && cleaned.startsWith('55')) {
            return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 4)} ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
        }
        // Formato local: 11 99999-9999  
        if (cleaned.length === 11) {
            return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
        }
        // Retorna original se não conseguir formatar
        return phoneNumber;
    };

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");

    const [selectedContact, setContact] = useState({
        id: 0,
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    // useEffect(() => {
    //     const delayDebounceFn = setTimeout(() => {
    //         const fetchContacts = async () => {
    //             try {
    //                 const number = numbers.replace(/\D/g, "");
    //                 const { data } = await api.get(`/contacts/profile/${number}`);

    //                 let obj = {
    //                     id: data.contactId,
    //                     name: contact,
    //                     number: numbers,
    //                     profilePicUrl: data.profilePicUrl
    //                 }

    //                 setContact(obj)

    //             } catch (err) {
    //                 console.log(err)
    //                 toastError(err);
    //             }
    //         };
    //         fetchContacts();
    //     }, 500);
    //     return () => clearTimeout(delayDebounceFn);
    // }, [contact, numbers]);


    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    if (isNil(numbers)) {
                        return
                    }
                    const number = numbers.replace(/\D/g, "");
                    const getData = await api.get(`/contacts/profile/${number}`);

                    if (getData.data.contactId && getData.data.contactId !== 0) {
                        let obj = {
                            id: getData.data.contactId,
                            name: contact,
                            number: numbers,
                            profilePicUrl: getData.data.urlPicture
                        }

                        setContact(obj)
                    } else {
                        let contactObj = {
                            name: contact,
                            number: number,
                            email: "",
                            companyId: companyId
                        }
                                                
                        const { data } = await api.post("/contacts", contactObj);
                        setContact(data)
                    }

                } catch (err) {
                    console.log(err)
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [companyId, contact, numbers]);

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");
    };

    const handleNewChat = async () => {
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
                queueId,
                companyId: companyId,
                whatsappId
            });

            history.push(`/tickets/${ticket.uuid}`);
        } catch (err) {
            try {
                const raw = err?.response?.data?.error;
                if (raw && typeof raw === 'string') {
                    const ticket = JSON.parse(raw);
                    if (ticket.userId !== user?.id) {
                        setOpenAlert(true);
                        setUserTicketOpen(ticket?.user?.name || "Outro atendente");
                        setQueueTicketOpen(ticket?.queue?.name || "Fila");
                    } else {
                        setOpenAlert(false);
                        setUserTicketOpen("");
                        setQueueTicketOpen("");
                        if (ticket?.uuid) {
                            history.push(`/tickets/${ticket.uuid}`);
                        } else {
                            history.push(`/tickets`);
                        }
                    }
                } else {
                    toastError(err);
                }
            } catch (e) {
                toastError(err);
            }
        }
    }

    return (
        <>
            <ShowTicketOpen
                isOpen={openAlert}
                handleClose={handleCloseAlert}
                user={userTicketOpen}
                queue={queueTicketOpen}
            />
            
            <Box className={classes.contactCard}>
                {/* 👤 Seção do Avatar e Informações */}
                <div className={classes.avatarSection}>
                    {selectedContact?.profilePicUrl || selectedContact?.urlPicture ? (
                        <Avatar 
                            src={selectedContact.profilePicUrl || selectedContact.urlPicture} 
                            className={classes.avatar}
                        />
                    ) : (
                        <Avatar className={classes.avatarFallback}>
                            {selectedContact.name ? selectedContact.name.charAt(0).toUpperCase() : contact?.charAt(0).toUpperCase() || '?'}
                        </Avatar>
                    )}
                    
                    <div className={classes.contactInfo}>
                        <Typography className={classes.contactName}>
                            {selectedContact.name || contact || 'Contato'}
                        </Typography>
                        
                        {(selectedContact.number || numbers) && (
                            <div className={classes.contactNumber}>
                                <Phone style={{ fontSize: '16px' }} />
                                {formatPhoneNumber(selectedContact.number || numbers)}
                            </div>
                        )}
                        
                        {/* 🏷️ Status Badge */}
                        <Chip
                            size="small"
                            label={selectedContact.id === 0 ? 'Novo Contato' : 'Contato Existente'}
                            className={`${classes.statusChip} ${
                                selectedContact.id === 0 ? classes.newContactChip : classes.existingContactChip
                            }`}
                        />
                    </div>
                </div>

                {/* 💬 Seção de Ação */}
                <div className={classes.actionSection}>
                    <Button
                        className={classes.actionButton}
                        onClick={handleNewChat}
                        disabled={!selectedContact.number && !numbers}
                        variant="contained"
                        startIcon={<WhatsApp className={classes.whatsappIcon} />}
                    >
                        Conversar
                    </Button>
                </div>
            </Box>
        </>
    );

};

export default VcardPreview;